import { addDays, addMonths, daysBetween, type ISODate, parseDate, toISO } from './dates';

export interface Cycle {
  start: ISODate;
  /** Dernier jour du cycle, inclus. */
  end: ISODate;
  dayCount: number;
  /**
   * Jours écoulés à la date de référence, celle-ci comprise : 1 le jour du
   * démarrage. Vaut 0 avant le cycle et `dayCount` après.
   */
  elapsedDays: number;
  /** Jours restants, aujourd'hui compris — celui qu'il reste à vivre. */
  remainingDays: number;
}

/**
 * Cycle contenant la date de référence, pour un jour de démarrage donné.
 *
 * Le jour de démarrage est borné à 28 par la base : un cycle commençant le 30
 * n'aurait pas de premier jour en février.
 */
export function resolveCycle(reference: ISODate, cycleStartDay: number): Cycle {
  const { year, month, day } = parseDate(reference);

  // Avant le jour de démarrage, on appartient encore au cycle du mois précédent.
  const anchor = toISO({ year, month, day: cycleStartDay });
  const start = day >= cycleStartDay ? anchor : addMonths(anchor, -1);
  const end = addDays(addMonths(start, 1), -1);

  const dayCount = daysBetween(start, end) + 1;
  const elapsed = daysBetween(start, reference) + 1;
  const elapsedDays = Math.min(Math.max(elapsed, 0), dayCount);

  return {
    start,
    end,
    dayCount,
    elapsedDays,
    remainingDays: Math.min(dayCount, dayCount - elapsedDays + 1),
  };
}
